import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { Wrapper, FrameWrapper, TextsSection, HeadingColor, Frame, ImageAudioWrapper, Image, SentenceWrapper, Question, ListeningInput, Correct, Topic, Header } from "./ListeningStyle"
import { ListeningData } from "./ListeningData"
import { colors } from "../../components/01_config/Colors"
import Player from "./03_player/Player"
import { TopicData } from "./04_topics/TopicsData"
import Topics from "./04_topics/Topics"
import useInstantScroll from "../../hooks/useInstalntScroll"
import ToTheTop from "../../components/04_common/02_tothetop/ToTheTop"
import { listening } from "../../i18n/08_listening"

const Listening = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = listening[lang]

  const [isGuest, setIsGuest] = useState(false)

  const groupByLessons = Array.from({ length: 30 }, (_, i) =>
    ListeningData.filter(value => value.lesson === i + 1)
  )

  const [listeningData, setListeningData] = useState(groupByLessons)

  const clickQuestion = (index, indexData, indexQuestion) => {
    setListeningData(prev =>
      prev.map((firstValue, firstIndex) =>
        firstIndex === index ?
          firstValue.map((secondValue, secondIndex) =>
            secondIndex === indexData ? {
              ...secondValue,
              questions: secondValue.questions.map((q, i) =>
                i === indexQuestion ? {
                  ...q,
                  visibility: q.visibility === "visible" ? "hidden" : "visible"
                } : q
              )
            } : secondValue
          ) : firstValue
      ))
  }

  const fillInput = (index, indexData, indexQuestion, newValue) => {
    setListeningData(prev =>
      prev.map((firstValue, firstIndex) =>
        firstIndex === index ?
          firstValue.map((secondValue, secondIndex) =>
            secondIndex === indexData ? {
              ...secondValue,
              questions: secondValue.questions.map((q, i) =>
                i === indexQuestion ? {
                  ...q,
                  input: q.input = newValue
                } : q
              )
            } : secondValue
          )
          : firstValue
      )
    )
  }


  const { jumpToHash } = useInstantScroll();

  const role = useSelector((s) => s.auth?.user?.role); // ✅ add
  const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

  const { lessons } = useSelector(state => state.studentLessons)

  const isLessonUnlocked = (lessonNumber) => {
    // ✅ TEACHER/ADMIN: show everything
    if (isPrivileged) return true;
    if (!lessons || lessons.length === 0) {
      return lessonNumber === 0;
    }
    const lesson = lessons.find((l) => l.order === lessonNumber)
    return !!lesson?.isUnlocked

  }

  const handleTopicClick = (lessonNumber) => {
    if (!isLessonUnlocked(lessonNumber)) return
    jumpToHash(`#lesson-${lessonNumber}`)
  }

  useEffect(() => {
    setIsGuest(!lessons || lessons.length === 0);
  }, [lessons]);

  return (
    <Wrapper>

      <Header >
        {t.header}
      </Header>
      <Topics
        isGuest={isGuest}
        isLessonUnlocked={isLessonUnlocked}
        handleTopicClick={handleTopicClick}
      />

      {listeningData.map((value, index) => {
        const lessonNumber = index + 1
        if (!isLessonUnlocked(lessonNumber)) {
          return null
        }

        return (
          <TextsSection
            key={index}
            id={`lesson-${lessonNumber}`}
          >
            <HeadingColor
            >
              Lesson {lessonNumber}
              <Topic>
                {TopicData[index].topic}
              </Topic>
            </HeadingColor>
            <FrameWrapper>
              {value.map((valueData, indexData) => (
                <Frame key={indexData}>
                  <ImageAudioWrapper>
                    <Image src={valueData.image} />
                    <Player audio={valueData.audio} />
                  </ImageAudioWrapper>
                  {valueData.questions.map((valueQuestion, indexQuestion) => (
                    <SentenceWrapper key={indexQuestion}>
                      <Question
                        onClick={() => clickQuestion(index, indexData, indexQuestion)}
                      >
                        {valueQuestion.question}
                      </Question>
                      &nbsp;
                      <ListeningInput
                        style={{ color: valueQuestion.input === valueQuestion.answer ? `${colors.greenWord}` : "" }}
                        onInput={(e) => fillInput(index, indexData, indexQuestion, e.target.value)}
                      />
                      <Correct style={{ visibility: valueQuestion.visibility }}>{valueQuestion.answer}</Correct>
                    </SentenceWrapper>
                  ))}
                </Frame>
              ))}
            </FrameWrapper>
          </TextsSection>
        )
      })}
      <ToTheTop />
    </Wrapper>
  )
}

export default Listening























// import React, { useState } from "react";

// const ReadingComponent = () => {
//   const [readingText, setReadingText] = useState(
//     images.map((image, index) => ({
//       id: index + 1,
//       lesson: index + 1,
//       text: text[index],
//       image,
//       questions: questions[index]
//     }))
//   );

//   // Function to update the visibility of a specific question
//   const updateVisibility = (lessonIndex, questionIndex) => {
//     setReadingText((prevReadingText) =>
//       prevReadingText.map((lesson, i) =>
//         i === lessonIndex
//           ? {
//               ...lesson,
//               questions: lesson.questions.map((q, j) =>
//                 j === questionIndex ? { ...q, visibility: "visible" } : q
//               ),
//             }
//           : lesson
//       )
//     );
//   };

//   return (
//     <div>
//       {readingText.map((lesson, lessonIndex) => (
//         <div key={lesson.id}>
//           <h2>Lesson {lesson.lesson}</h2>
//           <img src={lesson.image} alt={`Lesson ${lesson.lesson}`} width="200" />
//           {lesson.questions.map((q, questionIndex) => (
//             <div key={questionIndex}>
//               <p>{q.question}</p>
//               <input type="text" value={q.input} readOnly />
//               <button onClick={() => updateVisibility(lessonIndex, questionIndex)}>
//                 Show Answer
//               </button>
//               <span style={{ visibility: q.visibility }}>{q.answer}</span>
//             </div>
//           ))}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default ReadingComponent;



